import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`

export const Picker = styled.div`
  width: 200px;
`
